/*
 * @Author: klcxkjhsm huangshimin@klcxkj.com
 * @Date: 2024-07-18 10:24:47
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2024-07-26 18:41:41
 * @FilePath: \app-client-h5\src\pages\coupon\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component } from 'react';
import MD5 from '../../common/md5'
import { getVerifyCode, newRegister } from './service'
import { Toast, Mask, Checkbox, } from 'antd-mobile'
import { checkPassWord } from "../../utils/util"
import { GetRequest } from "../../utils/util";
import './index.scss';
class couponRegister extends Component {
    constructor(props) {
        super(props)
        this.state = {
            correct: require('../../assets/wancheng.png'),
            laba: require('./images/laba.png'),
            countDown: "获取验证码",
            telephone: null,
            verCodeBackColor: '#7accf5',
            checked: false,
            phone: null,
            phoneSuccess: false,
            visible: false,
            passWord: "",
            passWordAgain: "",
            close: require('./images/close-btn-icon.png'),
            accountId: null,
            token: null,
            activityId: null,
            userId: null,
            projectName: null,
            shareCode: null,
        }
    }
    componentDidMount() {
        let data = JSON.parse(GetRequest().data);
        window.localStorage.setItem('token', data.token);
        document.title = '活动详情'
        this.setState({
            projectId: data.projectId,
            accountId: data.accountId,
            token: data.token,
            activityId: data.activityId,
            userId: data.userId,
            projectName: data.projectName,
            shareCode: data.shareCode
        })
        document.title = '注册'
    }
    changeTelphoe() {
        let { telephone, passWord, passWordAgain, VerifyCode, checked, shareCode } = this.state
        if (!telephone) {
            Toast.show({
                icon: 'fail',
                content: '请输入手机号',
                duration: 1100,
            })
            return
        }
        if (!passWord) {
            Toast.show({
                icon: 'fail',
                content: '请输入密码',
                duration: 1100,
            })
            return
        }

        if (VerifyCode === "" || VerifyCode === undefined) {
            Toast.show({
                icon: 'fail',
                content: '请输入验证码',
                duration: 1100,
            })
            return
        }
        if (passWord === "" || passWord === undefined) {
            Toast.show({
                icon: 'fail',
                content: '请输入密码',
                duration: 1100,
            })
            return
        }
        if (!checkPassWord(passWord)) {
            Toast.show({
                icon: 'fail',
                content: '密码需8-16个字符且由数字或字母、特殊符号两种以上组成',
                duration: 1100,
            })
            return
        }
        if (passWord.length < 8 || passWord.length > 16) {
            Toast.show({
                icon: 'fail',
                content: '请输入8-16字符的密码',
                duration: 1100,
            })
            return
        }
        var patrn = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/gi;
        if (patrn.exec(passWord)) {
            Toast.show({
                icon: 'fail',
                content: '密码不能包含中文',
                duration: 1100,
            })
            return
        }
        var pattern = /\s/;
        if (pattern.test(passWord)) {
            Toast.show({
                icon: 'fail',
                content: '密码不能包含空格',
                duration: 1100,
            })
            return
        }
        if (passWord !== passWordAgain) {
            Toast.show({
                icon: 'fail',
                content: '2次密码不同',
                duration: 1100,
            })
            return
        }
        if (!checked) {
            Toast.show({
                icon: 'fail',
                content: '请阅读并勾选《用户协议、免责声明、隐私权政策》',
                duration: 1100,
            })
            return
        }
        let password = MD5.md5(passWord).toUpperCase();//MD5加密形成token
        password = password.slice(-10);
        let params = {
            telephone: telephone,
            password: password,
            code: VerifyCode,
        }
        if (shareCode) {
            params.shareCode = shareCode
        }
        newRegister(params).then(res => {
            if (res.errorCode === 0) {
                this.setState({
                    visible: true
                })
            } else {
                Toast.show({
                    icon: 'fail',
                    content: res.errorMessage,
                    duration: 1100,
                })
            }
        })

    }
    successClick() {
        this.setState({
            telephone: "",
            passWord: "",
            passWordAgain: "",
            visible: false,
            VerifyCode: "",
            shareCode: "",
        })
        const { projectName, accountId, projectId, token, activityId, userId, shareCode } = this.state;
        let data = {
            userId,
            accountId,
            token,
            activityId,
            projectId,
            shareCode,
            projectName
        }
        window.location.href = origin + '/coupon?data=' + JSON.stringify(data)

    }
    inputChange(e) {
        let value = e.currentTarget.value
        this.setState({
            telephone: value
        })
    }
    getPhoneCode() {
        let { telephone, countDown } = this.state
        if (!telephone) {
            Toast.show({
                icon: 'fail',
                content: '请输入手机号',
                duration: 1100,
            })
            return
        }
        if (countDown === '获取验证码' || countDown === '重新获取') {
            var tokenStr = telephone.substr(0, 3) + telephone.substr(7, 11) + "klcx";//
            var secret = MD5.md5(tokenStr).toLowerCase();//MD5加
            let params = {
                telephone,
                secret: secret,
                typeId: 1,//1、注册验证 2、修改密码
                platform: 1,
            }
            getVerifyCode(params).then(res => {
                if (res.errorCode === 0) {
                    this.countDown()
                    Toast.show({
                        icon: 'success',
                        content: '短信发送成功',
                        duration: 1100,
                    })
                } else {
                    Toast.show({
                        icon: 'fail',
                        content: res.errorMessage,
                        duration: 1100,
                    })
                }
            })
        }
    }
    setVisible() {
        this.setState({
            visible: false
        })
    }

    countDown() {
        let that = this
        //点击获取验证码向后台请求下发短信
        let i = 60;
        let timer;
        timer = setInterval(function () {
            if (i > 0) {
                i--
                that.setState({
                    countDown: i + 's',
                    verCodeBackColor: '#ccc'
                });
            } else {
                clearInterval(timer)
                that.setState({
                    countDown: '重新获取',
                    verCodeBackColor: '#7accf5'
                })
            }
        }, 1000)

    }
    onChangeCheck() {
        this.setState({
            checked: !this.state.checked
        })
    }
    codeInput(e) {
        this.setState({
            VerifyCode: e.currentTarget.value
        })
    }
    shareCodeInput(e) {
        this.setState({
            shareCode: e.currentTarget.value
        })
    }
    passWordInput(e) {
        //密码
        this.setState({
            passWord: e.currentTarget.value
        })
    }
    passWordAgainInput(e) {
        //确认密码
        this.setState({
            passWordAgain: e.currentTarget.value
        })
    }
    render() {
        const { projectName, telephone, countDown, close, correct, laba, visible, checked, VerifyCode, passWord, shareCode, passWordAgain } = this.state
        return (
            <div >
                <div className="couponRegister-page" style={{ display: 'flex', flexDirection: 'column', padding: '0.62rem 0' }}>
                    <div className='telTab'>
                        <div className='text' ><span className="yd">*</span>手机号</div>
                        <input
                            placeholder='请输入手机号'
                            type='text'
                            name="input"
                            maxLength='16'
                            defaultValue={telephone}
                            onBlur={(e) => this.inputChange(e)}
                        >
                        </input>
                    </div>

                    <div className='telTab'>
                        <div className='text'  ><span className="yd">*</span>验证码</div>
                        <div className='code-div'>
                            <input
                                className='input'
                                type='text'
                                defaultValue={VerifyCode}
                                placeholder="请输入验证码"
                                confirm-type="done"
                                onBlur={(e) => this.codeInput(e)}
                                style={{ width: '70%' }}
                            />
                            <button className='countDown' type='button' onClick={() => this.getPhoneCode()} size="mini" >{countDown}</button>
                        </div>
                    </div>
                    <div className='telTab'>
                        <div className='text' ><span className="yd">*</span>密码</div>
                        <input
                            placeholder='请输入8-16字符的新密码'
                            type='password'
                            defaultValue={passWord}
                            name="input"
                            onBlur={(e) => this.passWordInput(e)}
                            maxLength='16'
                        >
                        </input>
                    </div>
                    <div className='telTab'>
                        <div className='text' ><span className="yd">*</span>确认密码</div>
                        <input
                            placeholder='请再输入8-16字符的新密码'
                            type='password'
                            name="input"
                            defaultValue={passWordAgain}
                            onBlur={(e) => this.passWordAgainInput(e)}
                            maxLength='16'
                        >
                        </input>
                        <div className='password-tips'>
                            <img src={laba} alt="" />
                            <p>密码为8-16位,包含数字、字母和特殊字符两种及以上</p>
                        </div>
                    </div>
                    {
                        shareCode ?
                            <div className='telTab'>
                                <div className='text' >注册邀请码</div>
                                <input
                                    placeholder='请输入注册邀请码'
                                    type='text'
                                    name="input"
                                    disabled
                                    defaultValue={shareCode}
                                    onBlur={(e) => this.shareCodeInput(e)}
                                    maxLength='16'
                                >
                                </input>
                            </div>
                            : null
                    }

                    <div style={{ marginLeft: '32px', display: 'flex', flexDirection: 'row', fontSize: '12px' }}>
                        <Checkbox onChange={() => this.onChangeCheck()} defaultChecked={checked} style={{ fontSize: '12px' }}>
                            已阅读
                        </Checkbox>
                        <div>
                            <a href='https://oss.china-qzxy.cn/ap/Useragreement.html' className="checkbox" >用户协议 </a>
                            {/* <a className="checkbox" href='https://oss.china-qzxy.cn/ap/mzsm.html'>、免责声明</a>
                            <a className="checkbox" href='https://oss.china-qzxy.cn/ap/secretApply.html'>、隐私权政策</a> */}
                        </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <button type='button' className='login btn' onClick={() => this.changeTelphoe()}>
                            注册
                        </button>
                    </div>
                    <Mask visible={visible} >
                        <div className='modal'>
                            <div className='header-img'>
                                <img className='img-logo' src={correct} alt="" />
                                <img className='img-close' src={close} alt="" onClick={() => this.setVisible()} />
                            </div>
                            <div className='header-title'>注册成功</div>
                            <div className='body-content'>
                                <div>请在应用市场下载“趣智校园”APP，或在微信/支付宝搜索“趣智校园”小程序，登录绑定项目：{projectName}</div>
                                <div className='content-tips'>绑定项目后，才可获得注册优惠券</div>
                            </div>
                            <button className='btn submit' onClick={() => this.successClick()}>确定</button>
                        </div>
                    </Mask>
                </div>
            </div>
        );
    }
}

export default couponRegister;
